import uniq from 'utils/uniq';
import { PAGE_OPTION, TREE_TYPE, TREE_TYPE_ALIASES } from './constants';

export function getTreeTypeFromPage(page) {
  // Handle family-summary pages as descendant tree type
  if (page.id?.indexOf('family-summary') >= 0) {
    return TREE_TYPE.DESC;
  }

  if (page.optionId !== PAGE_OPTION.FAMILY_TREE) {
    return null;
  }

  return Object.keys(TREE_TYPE_ALIASES).find((treeType) =>
    TREE_TYPE_ALIASES[treeType].some((value) => page.id.indexOf(value) >= 0),
  );
}

export function usePageThisTreeType(pageId, treeType) {
  let valid = false;
  if (TREE_TYPE_ALIASES[treeType]) {
    valid = TREE_TYPE_ALIASES[treeType].some((value) => pageId.indexOf(value) >= 0);
  }
  return valid;
}

export function getFamilyTreeTypes(template) {
  const types = [];

  const getTypeFromAnyValue = (value) => {
    let type;
    Object.entries(TREE_TYPE_ALIASES).forEach(([key, values]) => {
      if (values.indexOf(value) >= 0) {
        type = key;
      }
    });
    return type;
  };

  // first search pages by optionId
  template.pages.forEach((page) => {
    if (page.optionId === 'family-tree') {
      const value = page.id.split('-').pop();
      const type = getTypeFromAnyValue(value);
      if (type) {
        types.push(type);
      }
    }
  });

  // when no page has defined type, try sku
  if (types.length === 0) {
    if (template.id.indexOf('fh') === 0) {
      const value = template.id.split('-').pop();
      const type = getTypeFromAnyValue(value);
      if (type) {
        types.push(type);
      }
    }
  }

  return uniq(types);
}

export function getNumberOfGenerationsFromPage(page) {
  let value;

  page.id
    .split('-')
    .filter((part) => part.endsWith('g'))
    .forEach((part) => {
      // parseInt yields NaN for non-numeric parts, and NaN > 0 is false, so a
      // bad part is simply ignored without needing a try/catch.
      const numberOfGenerations = parseInt(part.replace('g', ''), 10);
      if (numberOfGenerations > 0) {
        value = numberOfGenerations;
      }
    });

  return value;
}

export function getNumbersOfGenerations(template, suitableValues = [], type = undefined) {
  const numbersOfGenerations = [];

  if (template?.pages) {
    template.pages
      .filter((page) => {
        if (type != null) {
          if (!usePageThisTreeType(page.id, type)) {
            return false;
          }
        }
        return true;
      })
      .forEach((page) => {
        const numberOfGenerations = getNumberOfGenerationsFromPage(page);
        if (numberOfGenerations != null) {
          if (suitableValues.length > 0 && suitableValues.indexOf(numberOfGenerations) < 0) {
            // TODO when defined, allow only suitableValues
            return;
          }
          numbersOfGenerations.push(numberOfGenerations);
        }
      });
  } else {
    numbersOfGenerations.push(...suitableValues);
  }

  return uniq(numbersOfGenerations).sort();
}

export function getDefaultNumberOfGenerations(template, suitableValues = [], type = undefined) {
  const numbersOfGenerations = getNumbersOfGenerations(template, suitableValues, type);

  if (numbersOfGenerations.length > 0) {
    return numbersOfGenerations[0];
  }

  return undefined;
}
